
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import StepCard from "@/components/StepCard";
import { getAssetPath } from "@/utils/assetUtils";

const HowDiscoWorks = () => {
  const [ctaButtonLoaded, setCtaButtonLoaded] = useState(false);
  const [ctaButtonPath, setCtaButtonPath] = useState("");
  
  useEffect(() => {
    console.log("HowDiscoWorks: Loading CTA button image");
    
    // Try to load the image
    const img = new Image();
    img.onload = () => {
      console.log("✅ Successfully loaded CTA button path:", img.src);
      setCtaButtonPath(img.src);
      setCtaButtonLoaded(true);
    };
    img.onerror = (e) => {
      console.error("❌ Failed to load CTA button image:", e);
      setCtaButtonLoaded(false);
    };
    img.src = getAssetPath("landing_start_onboarding_cta.png");
  }, []);
  
  return (
    <section className="py-24 px-6 md:px-10 bg-[#F6F6F7] text-black">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12">
          <div className="lg:col-span-4">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">How Disco Works</h2>
            
            <div className="mb-12">
              <p className="text-gray-600">
                Disco was created by hospitality industry veterans to support and expand the luxury-event transportation business. We have decades of experience and relationships and are building a more fluid marketplace so that drivers, riders, and events win.
              </p>
            </div>
            
            <Link to="/register-new" className="inline-block mb-8 relative z-10">
              {!ctaButtonLoaded ? (
                <button className="bg-green-500 text-black font-bold py-3 px-6 rounded hover:bg-green-400 transition-colors">
                  Start Onboarding
                </button>
              ) : (
                <img 
                  src={ctaButtonPath} 
                  alt="Start Onboarding" 
                  className="h-12 hover:opacity-90 transition-opacity cursor-pointer"
                />
              )}
            </Link>
          </div>
          
          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 md:hidden gap-10">
              <StepCard 
                number="1"
                title="Sign Up & become a verified driver"
                icon={<></>}
                description="Get approved in 24 hours or less."
              />
              
              <StepCard 
                number="2"
                title="We send you clients from our nightlife network"
                icon={<></>}
                description="Earn an extra $1000 per weekend."
              />
              
              <StepCard 
                number="3"
                title="Complete trips and get paid"
                icon={<></>}
                description="The better your ratings, the more trips you get!"
              />
            </div>
            
            <div className="hidden md:grid grid-cols-2 gap-10">
              <div className="space-y-10">
                <StepCard 
                  number="1"
                  title="Sign Up & become a verified driver"
                  icon={<></>}
                  description="Get approved in 24 hours or less."
                />
                
                <StepCard 
                  number="3"
                  title="Complete trips and get paid"
                  icon={<></>}
                  description="The better your ratings, the more trips you get!"
                />
              </div>
              
              <div className="space-y-10 mt-20">
                <StepCard 
                  number="2"
                  title="We send you clients from our nightlife network"
                  icon={<></>}
                  description="Earn an extra $1000 per weekend."
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowDiscoWorks;
